<script lang="ts">
	export let style: string = ``
	export let disabled: boolean | undefined = false
	export let type: `button` | `reset` | `submit` = `button`

	export let this_button: HTMLButtonElement | null = null

	const manually_focus_for_safari = () => {
		this_button?.focus()
	}
</script>

<button
	bind:this={this_button}
	on:click={manually_focus_for_safari}
	on:click
	on:focus
	on:mousedown
	{style}
	{disabled}
	{type}
	{...$$restProps}
>
	<slot></slot>
</button>

<style>
	button {
		background-color: var(--chemlight);
		color: #2a2a2b;
		padding: 10px 20px;
		border: none;
		border-radius: var(--default-border-radius);
		cursor: pointer;
		font-weight: bold;
		letter-spacing: 1px;
		font-weight: 500;
	}

	button:disabled {
		background-color: #ccc;
		color: #666;
		cursor: not-allowed;
	}
</style>
